import { Container, CssBaseline, Grid } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import React, { useState } from "react";
import "./App.css";
import Header from "./components/Header";
import ProductCard from "./components/ProductCard";
import SearchBar from "./components/SearchBar";
import Snackbar from "@mui/material/Snackbar";

function App() {
  const darkTheme = createTheme({
    palette: {
      mode: "dark",
    },
  });

  const [products, setProducts] = useState([]);
  const [searchedOnce, setSearchedOnce] = useState(false);

  const handleSearch = (filteredProducts) => {
    setProducts(filteredProducts);
    setSearchedOnce(true);
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div className="App">
        <center>
          <Header />
          <Container maxWidth="sm" sx={{ mt: 2 }}>
            <SearchBar onSearch={handleSearch} />
          </Container>
          <Container sx={{ mt: 4 }}>
            <Grid container spacing={3}>
              {products.length > 0 ? (
                products.map((product) => (
                  <Grid item xs={12} md={6} key={product.id}>
                    <ProductCard product={product} />
                  </Grid>
                ))
              ) : (
                <Snackbar
                  open={searchedOnce}
                  autoHideDuration={6000}
                  // onClose={handleClose}
                  message="No products found matching search"
                  // action={action}
                />
              )}
            </Grid>
          </Container>
        </center>
      </div>
    </ThemeProvider>
  );
}

export default App;
